import React from 'react';
import * as Styles from './RadioBlock.styles';
import { Radio } from 'gatorcomponents';

const RadioBlock = ({
  optionId, onClick, selected, titleLabel, descriptionLabel, discountLabel, priceLabel, bottomTextLabel,
}) => (
  <Styles.RadioBlock
    key={optionId}
    data-testid={`radio-block-${optionId}`}
    onClick={onClick}
    selected={selected}
  >
    <Radio id={optionId} checked={selected} variant="blue" />
    <Styles.RadioBlockContent>
      {titleLabel && <Styles.RadioBlockTitle>{titleLabel}</Styles.RadioBlockTitle>}
      {descriptionLabel && <Styles.RadioBlockDescription>{descriptionLabel}</Styles.RadioBlockDescription>}
      {discountLabel && <Styles.RadioBlockDiscount>{discountLabel}</Styles.RadioBlockDiscount>}
      {priceLabel && <Styles.RadioBlockPrice>{priceLabel}</Styles.RadioBlockPrice>}
      {bottomTextLabel && <Styles.RadioBlockBottomText>{bottomTextLabel}</Styles.RadioBlockBottomText>}
    </Styles.RadioBlockContent>
  </Styles.RadioBlock>
);

export default RadioBlock;
